import { ServiceData } from '../../service';
import db from '../../index';
import { entityServiceFactory } from '../../entityServiceFactory';

export interface RejectionReasonsServiceData extends ServiceData {}
const { add, clear, addSync, stopDownloading, get, reset, requestDownloadAgain } =
  entityServiceFactory<RejectionReasonsServiceData>(
    db,
    'rejectionReasonsService'
  );

export { add, clear, addSync, stopDownloading, get, reset, requestDownloadAgain };
